import HttpClienteSeguroClass from '../../Servicios/HttpClienteSeguroClass';

// Obtiene el listado de los adjuntos de lo requisitos de una admision
// RequirementId: Identificador del requisito de admisi�n
// AccionPeticionValidar: Permisos de usuario para realizar la operaci�n
export const ListadoAdjuntosRequisitos = (filtro) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroClass.post('/AdmisionesReqAdjuntos/Listar', filtro).then(response => {
            resolve(response);
        });
    });
};

// Inserta el registro de control adjunto de un requisito de admisi�n
// RequirementId: Identificador del requisito
// FileName: Nombre del archivo
// MimeType: Tipo de contenido
// UserId: Identificador del usuario
// CompanyId: Identificador de la compa��a
// AccionPeticionValidar: Permisos de usuario para realizar la operaci�n
export const InsertarAdjuntoRequisitos = (admision) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroClass.post("/AdmisionesReqAdjuntos/Insertar/", admision).then(response => {
            resolve(response);
        })
            .catch(error => {
                resolve(error.response);
            });
    });
};

// Elimina el registro de control adjunto de un requisito de admisi�n
// FileId: Identificador del fichero
// UserId: Identificador del usuario
// CompanyId: Identificador de la compa��a
// AccionPeticionValidar: Permisos de usuario para realizar la operaci�n
export const EliminarAdjuntoRequisito = (registro) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroClass.post("/AdmisionesReqAdjuntos/Eliminar/", registro).then(response => {
            resolve(response);

        })
            .catch(error => {
                resolve(error.response);
            });
    });
};


// Inserta el registro de control adjunto de un requisito de admisi�n
// Id: Identificador del adjunto
// CustomerId: Id del cliente/estudiante
// UserId: Identificador del usuario
// CompanyId: Identificador de la compa��a
export const InsertarAuditoriaConsultaAdjunto = (adjunto) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroClass.post("/AdmisionesReqAdjuntos/AuditoriaConsulta/", adjunto).then(response => {
            resolve(response);
        })
            .catch(error => {
                resolve(error.response);
            });
    });
};

export default ListadoAdjuntosRequisitos